export default function BooleanIndicator({ value }) {
	return <div style={{ paddingTop: 'var(--u-2)', marginBottom: 'calc(-1 * var(--u-2))' }}>
		{value && <span className="fa fa-check-circle" style={{ color: 'var(--col-green-500)', fontSize: '13pt' }} />}
		{!value && <span className="fa fa-times-circle" style={{ color: 'var(--col-red-500)', fontSize: '13pt' }} />}
	</div>;
}